import { QueueListIcon } from "@heroicons/react/24/outline";
import { lazy } from "react";

import type { FeatureMetadata } from "../../feature.types";

export const SubjectsFeature: FeatureMetadata = {
  id: "subjects",
  moduleName: "academics",

  navigation: {
    label: "Subjects",
    path: "/subjects",
    icon: QueueListIcon,
    order: 3,
  },

  route: {
    path: "/subjects",
    element: lazy(() => import("./pages/Subjects")),
  },

  // Reuse the existing permission family already used by Classes.
  permissions: {
    view: "Academics.Subjects.view",
    create: "Academics.Subjects.create",
    edit: "Academics.Subjects.edit",
    delete: "Academics.Subjects.delete",
  },

  readiness: "live",
};
